export default "__VITE_ASSET__DVLKi9RN__"